import React, { useState, useEffect, useRef, useContext } from "react";
import { PiCaretDown, PiCaretRight } from "react-icons/pi";
import { Logo } from "./CoazIcons";
import { FaPaperPlane, FaPhoneAlt } from "react-icons/fa";
import { FaBars } from "react-icons/fa6";
import {rootMenu} from "../data";
import Search from "../components/Search";
import { renderToStaticMarkup } from 'react-dom/server'
import { useInRouterContext, NavLink, useNavigate } from "react-router-dom";
import ReactDOM from "react-dom/client";
import Login from "./Login";
import { GlobalContext } from "../contexts/GlobalContext";
import { useData } from "../data";
import authClient from "../client";
import EditModeToggle from "./EditModeToggle";
import UserProfileButton from "./UserProfileButton";
import EditableComplonent from "./EditableComponent";
import MobileMenu from "./MobileMenu";

//Measurement functions(Measures the width of the component by rendering it to static markup and measuring the resulting element.)
const calcWidth = (Component) => {
    // If no component is provided, return 0 width
    if (!Component) {
        return 0;
    }
    // Create a temporary span element to render the component and measure its width
    let span = document.createElement("span");
    document.body.appendChild(span);
    // Set styles to ensure the element does not affect page layout
    
    span.style.height = '0';// inviible height to prevent affecting layout
    span.style.width = 'fit-content';
    span.style.position = 'absolute';
    span.style.overflow = 'hidden'; // Hide overflow
    span.style.whiteSpace = 'no-wrap'; // prevent text from wrapping
    
    // Render the component to static markup and set it as the innerHTML of the span
    span.innerHTML = renderToStaticMarkup(Component);
    let width = Math.ceil(span.clientWidth);
    // Clean up by removing the temporary span element from the document
    document.body.removeChild(span);
    return width;
}
//Measures Component Width and Height
const calcSize = (Component) => {
    if (!Component) {
        return {width: 0, height: 0};
    }
    let span = document.createElement("span");
    document.body.appendChild(span);
    span.style.height = 'fit-content';
    span.style.width = 'fit-content';
    span.style.position = 'absolute';
    span.style.overflow = 'hidden';
    span.style.whiteSpace = 'no-wrap';
    span.innerHTML = renderToStaticMarkup(Component);
    let width = Math.ceil(span.clientWidth);
    let height = Math.ceil(span.clientHeight);
    document.body.removeChild(span);
    return {width: width, height: height};
}

const Menu = () => {
    const {loading,setLoading,editing,setEditing,version} = useContext(GlobalContext);
    const [selected, setSelected] = useState(null);
    const [navbarMenus,setNavbarMenus] = useState(null); 
    const [user,setUser] = useState(null);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [menusLoaded, setMenusLoaded] = useState(false);
    const [headerHeight, setHeaderHeight] = useState(0);
    const menuButtonsRef = useRef(null);
    const highlightRef = useRef(null);
    const headerRef = useRef(null);
    const more = 'More';

    //Authentication functions(client).
    const {request,getCurrent} = authClient;

    //Called when the mouse enters a menu item. It updates the position and width of the highlight element to match the hovered menu item.
    const onEnter = (e) => {
        e.preventDefault();// prevent default behavior of the event (e.g., navigation).
       
        // Check if the highlight element exists before trying to update its position and width.
        if (highlightRef.current) {
            let padding = 16;
            let x = e.target.offsetLeft;
            let width = e.target.offsetWidth;
           
            // poition the highlight element under the hovered menu item.
            highlightRef.current.style.left = x + padding + "px";
            highlightRef.current.style.width = width - padding * 2 + "px";
        }
    };

    // Called when the mouse leaves a menu item.
    const onLeave = (e) => {
        e.preventDefault();
       
        if (selected) {
        const active = document.getElementById(selected);
        if (active) {
            let padding = 16;
            let x = active.offsetLeft;
            let width = active.offsetWidth;
            // Check if the highlight element exists before trying to update its position and width.
            if (highlightRef.current) {
                highlightRef.current.style.left = x + padding + "px";
                highlightRef.current.style.width = width - padding * 2 + "px";
            }
        }
        }
    };

    // Reduces the number of menus by moving the last two menus into a "More" dropdown menu if necessary.
    const reduceMenus = (menus) => {
        if (!menus || menus.length < 1) {
            return;
        }
        // Check if the last menu is the "More" menu. 
        if (menus.length > 1 && menus[menus.length - 1].name === more) {
            //Remove the second to last menu and add it to the beginning of the "More" menu's submenus.
            let removed = menus.splice(menus.length - 2, 1);
            // If a menu was removed, add it to the beginning of the "More" menu's submenus.
            if (removed.length > 0) {
                menus[menus.length - 1].menus.unshift(removed[0]);
            }
        } else if (menus.length > 2) {
            let subMenus = [];
            subMenus.push(menus.pop());
            subMenus.push(menus.pop());
            menus.push({
                name: more,
                menus: subMenus
            })
        }
    }

    
    const loadUser = async () => {
        await getCurrent()
        .then((response) => {
            if(response && response.user) {
                setUser(response.user);
            } else {
                setUser(null);
                setEditing(false);
            }
        })
        .catch(() => {
            setUser(null);
            setEditing(false);
        })
    }

    const toggleMobileMenu = () => {
        if(menusLoaded){
            setMobileMenuOpen(!mobileMenuOpen);
        }
        
    }

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
    }

    useEffect(() => {
        console.log('loading...')
        loadUser();
    },[version])

    useEffect(() => {
        // Set up a ResizeObserver to monitor changes in the width of the menu buttons container.
        const observer = new ResizeObserver(entries => {
            for (let entry of entries) {
                let btnsWidth = entry.target.offsetWidth;
                if (btnsWidth > 1 && rootMenu && rootMenu.menus && rootMenu.menus.length > 0) {
                    let menusCopy = JSON.parse(JSON.stringify(rootMenu.menus));
                    let width = calcWidth(
                        <div className="relative flex flex-row w-fit h-fit px-4">
                            {menusCopy && menusCopy.length > 0 && menusCopy.map((menu, i) =>
                                <MenuButton
                                    key={i}
                                    name={menu.name ? menu.name : ''}
                                    link={menu.link ? menu.link : '/'}
                                    menus={menu.menus && menu.menus.length > 0 ? menu.menus : null}
                                />
                            )}
                        </div>
                    );

                    for (; width > btnsWidth;) {
                        reduceMenus(menusCopy);
                        width = calcWidth(
                            <div className="relative flex flex-row w-fit h-fit px-4">
                                {menusCopy && menusCopy.length > 0 && menusCopy.map((menu, i) =>
                                    <MenuButton
                                        key={i}
                                        name={menu.name ? menu.name : ''}
                                        link={menu.link ? menu.link : '/'}
                                        menus={menu.menus && menu.menus.length > 0 ? menu.menus : null}
                                    />
                                )}
                            </div>
                        );
                    }

                    setNavbarMenus(menusCopy);
                    setMenusLoaded(true);
                }
            }
        });
        if (menuButtonsRef.current) {
            observer.observe(menuButtonsRef.current)
        }

        //FallBack Timeout
        const timeoutId = setTimeout(() => {
            if(!menusLoaded && rootMenu && rootMenu.menus && rootMenu.menus.length > 0){
                const menusCopy = JSON.parse(JSON.stringify(rootMenu.menus));
                setNavbarMenus(menusCopy);
                setMenusLoaded(true);
            }
        }, 500);
        return () => {
            observer.disconnect();
            clearTimeout(timeoutId);
            document.body.classList.remove('no-scroll');
        };
    }, []);

    // Scroll event listener to make header fixed when scrolling
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 1);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        const updateHeaderHeight = () => {
            if (headerRef.current) {
                setHeaderHeight(headerRef.current.offsetHeight);
            }
        };

        updateHeaderHeight();
        window.addEventListener('resize', updateHeaderHeight);

        return () => window.removeEventListener('resize', updateHeaderHeight);
    }, [isScrolled]);

    const px = 'px-4 xs:px-[8%] sm:px-[13%] md:px-[5%] xl:px-[13%]'

    // Calculate scale factor for scrolled state (0.7 = 70% of original size)
    const scaleFactor = isScrolled ? 0.7 : 1;
    const topPadding = isScrolled ? 6 : 16;
    const bottomPadding = isScrolled ? 6 : 16;
    const logoSize = isScrolled ? 32 : 56;
    const logoSizeSm = isScrolled ? 48 : 80;
    const textSize = isScrolled ? 'text-xl md:text-4xl' : 'text-4xl md:text-5xl';
    const searchHeight = isScrolled ? 'h-6' : 'h-8';
    const searchIconSize = isScrolled ? 14 : 20;
    const mobileSearchHeight = isScrolled ? 'h-10' : 'h-14';
    const mobileSearchPadding = isScrolled ? 'px-2' : 'px-4';
    const marginTop = isScrolled ? 'mt-1' : 'mt-3';

    const navigate = useNavigate();

 return (
        <>
            <div
                aria-hidden="true"
                className="w-full shrink-0"
                style={{ height: isScrolled && headerHeight > 0 ? `${headerHeight}px` : '0px' }}
            />
            
            {/* Main Header */}
            <div 
                ref={headerRef}
                className={`flex flex-col w-full bg-center bg-cover shrink-0 transition-all duration-300 ${
                    isScrolled ? 'fixed top-0 left-0 right-0 z-40 shadow-md' : 'relative'
                }`}
                style={{ 
                    backgroundImage: 'url(/images/bg_8.jpg)',
                    paddingTop: '16px',
                    paddingBottom: window.innerWidth >= 768 ? '0px' : '16px'
                }}>
                
                {/* Background Overlay */}
                <div style={{ background: 'linear-gradient(to right, #1566ad 0%, #1b9de3 100%)', opacity: '.8' }}
                    className="absolute left-0 top-0 w-full h-full" />

                
                {/* Top Bar */}
                <div className={`flex flex-row w-full h-auto ${px} z-10 items-center justify-between text-white shrink-0` }>
                    {/* Logo Section */}
                    <div className="flex flex-row items-center gap-2 md:gap-4">
                        <button id="logo-container"
                            style={{ transition: "all .3s ease-in-out" }}
                            className={`flex items-center justify-center shrink-0 ${
                                isScrolled 
                                    ? 'w-[32px] h-[32px] md:w-[48px] md:h-[48px]' 
                                    : 'w-[56px] h-[56px] sm:w-[80px] sm:h-[80px]'
                            }`}
                            onClick={(e) => {
                                e.preventDefault()
                                navigate('/')
                            }}
                        >
                            <Logo fill="white" />
                        </button>
                        <p className={`font-nunitoSansBlack transition-all duration-300 ${
                            isScrolled ? 'text-xl md:text-3xl' : 'text-4xl md:text-5xl'
                        }`}>COAZ</p>
                    </div>
                    
                    {/* Right Side Controls */}
                    <div className="flex flex-row w-fit h-fit text-sm space-x-4 md:space-x-8 items-center">
                        {/* Contact Info - Hidden on mobile when scrolled to save space */}
                        <div className={`hidden xl:flex flex-row items-center space-x-1 transition-all duration-300 ${
                            isScrolled ? 'text-xs' : ''
                        }`}>
                            <FaPaperPlane size={isScrolled ? 16 : 20} />
                            <p className="font-nunitoSansSemiBold">Email :</p>
                            <p className="font-nunitoSansLight">info@coaz.com</p>
                        </div>
                        <div className={`hidden xl:flex flex-row items-center space-x-1 transition-all duration-300 ${
                            isScrolled ? 'text-xs' : ''
                        }`}>
                            <FaPhoneAlt size={isScrolled ? 16 : 20} />
                            <p className="font-nunitoSansSemiBold">Cell :</p>
                            <p className="font-nunitoSansLight">+260 979 123 456</p>
                        </div>
                        
                        {/* Search */}
                        <div className="hidden md:block w-fit h-fit space-x-2 transition-all duration-300">
                            <Search/>
                        </div>
                        
                        {/* Auth Buttons */}
                        {!user ? (
                            <div className="flex flex-row items-center space-x-1 md:space-x-2">
                               <button onClick={() => {
                                        window.location.href = "https://auth.coaz.org/_register"
                                    }}
                                        className="p-1 w-auto font-nunitoSansRegular text-white rounded-full cursor-pointer shrink-0 text-nowrap hover:opacity-80 transition-opacity">
                                        Register
                                </button>
                                <div className={`border-l border-white transition-all duration-300 ${
                                    isScrolled ? 'h-3' : 'h-4'
                                }`} />
                                <button onClick={() => {
                                    window.location.href = `https://auth.coaz.org/_login?successUrl=${window.location.href}`
                                }}
                                    className={`p-1 w-auto font-nunitoSansRegular text-white rounded-full cursor-pointer shrink-0 text-nowrap hover:opacity-80 transition-all duration-300 ${
                                        isScrolled ? 'text-xs md:text-sm' : ''
                                }`}>
                                    Log In
                                </button>
                            </div>
                        ) : (
                            <div className="flex flex-row items-center space-x-2">
                                <EditModeToggle />
                                <UserProfileButton />
                            </div>
                        )}
                    </div>
                </div>
                
                <div ref={menuButtonsRef}
                        className="hidden md:flex py-2 w-full h-16 sm:h-16 px-2 sm:px-4 items-center z-10 bg-white shrink-0 shadow-lg"
                        style={{ marginTop: '15px' }}>
                        <div className="relative hidden sm:flex flex-row w-full h-fit items-center justify-center">
                        {navbarMenus && navbarMenus.length > 0 && navbarMenus.map((menu, i) =>
                            <MenuButton
                                key={i}
                                name={menu.name ? menu.name : ''}
                                link={menu.link ? menu.link : '/'}
                                menus={menu.menus && menu.menus.length > 0 ? menu.menus : null}
                                setSelected={setSelected}
                                onEnter={onEnter}
                                onLeave={onLeave}
                            />
                        )}
                    </div>
                </div>
                
               {/* Mobile Menu Toggle */}
                <div className={`relative md:hidden w-full transition-all duration-300 ${px}`}>
                    <div className={`flex flex-row w-full bg-white gap-2 rounded-full items-center justify-between z-10 overflow-hidden transition-all duration-300 ${
                        isScrolled ? 'h-10' : 'h-14'
                    } ${isScrolled ? 'px-2' : 'px-4'}`}
                        style={{ marginTop: isScrolled ? '4px' : '12px' }}>
                        <button
                            className="flex w-8 h-8 text-theme items-center justify-center cursor-pointer shrink-0 touch-target"
                            onClick={toggleMobileMenu}
                            aria-label="Toggle menu"
                            disabled={!menusLoaded}
                        >
                            <FaBars size={isScrolled ? 16 : 20} />
                        </button>

                        {/* Search Container */}
                        <div className='flex-1 min-w-0 h-fit'>
                            <Search isMobile={true} isCompact={isScrolled} />
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile Menu Component */}
            <MobileMenu
                isOpen={mobileMenuOpen && menusLoaded}
                onClose={closeMobileMenu}
                navbarMenus={navbarMenus}
                user={user}
                setSelected={setSelected}
                onEnter={onEnter}
                onLeave={onLeave}
                selected={selected}
                menusLoaded={menusLoaded}
            />
        </>
    );
};

export default Menu;


const MenuButton = ({name, link, menus, parentRef, setSelected, onEnter, onLeave, closeParentDropDown, mobileMode}) => {
    const [droppedDown, setDroppedDown] = useState(false); // State to track whether the dropdown menu is currently open or closed.
    
    const menuRef = useRef(null); // Ref for the menu button element, used to position the dropdown menu relative to it.
    const dropDownRef = useRef(null); // Ref for the dropdown menu element, used to control its visibility and position.
    const menusRef = useRef(null); // Ref for the container of the dropdown menu items, used to control its overflow behavior during animations.
    const closeTimeoutRef = useRef(null); //+ Ref to store the timeout ID for closing the dropdown menu.
    const animationRef = useRef(null); // Ref to store the current animation instance for the dropdown menu.
    const [isHovered, setIsHovered] = useState(false); // State to track whether the menu button is currently being hovered over.
    
    const isInRouterContext = useInRouterContext(); // Check if the component is rendered within a Router context.

    //+ Cleanup timeouts and animations on unmount.
    useEffect(() => {
        return () => {
            //+ Clear any pending close timeout  and cancel any ongoing animation when the component unmounts to prevent memory leaks and unintended behavior.
            if (closeTimeoutRef.current) clearTimeout(closeTimeoutRef.current);
            if (animationRef.current) animationRef.current.cancel?.();
        };
    }, []);

    const dropDown = () => {
        // ONly open if it's not already open to prevent redundant state updates and animations.
        if (!droppedDown) {
            if (menuRef.current && dropDownRef.current && menusRef.current) {
                // Find the parent header for positioning the dropdown menu relative to it. 
                let parent = menuRef.current;
                do {
                    parent = parent.parentElement;
                } while (parent && parent.tagName.toLowerCase() != 'header');
                if (parent) {
                    let size = calcSize(
                        <div className="flex flex-col w-fit h-fit px-4 overflow-visible">
                            {menus && menus.length > 0 && menus.map((menu, i) =>
                                <MenuText key={i} name={menu.name} menus={menu.menus} parentRef={menuRef} isCalc={true}/>
                            )}
                        </div>
                    );
                    let viewWidth = parent.clientWidth;
                    let menuRect = menuRef.current.getBoundingClientRect();
                    // Make menu visible for overflow.
                    menuRef.current.style.overflow = 'visible';
                    // Position the dropdown menu based on available space and whether it has a parent menu (for submenus).
                    if (parentRef) {
                        //Submenu Positioning.
                        dropDownRef.current.style.top = '0';
                        if ((menuRect.right + size.width) > viewWidth) {
                            // Position to the left if it would overflow on the right.
                            dropDownRef.current.style.left = (0 - size.width) + 'px';
                        } else {// Position to the right.
                            dropDownRef.current.style.left = '100%';
                        }
                    } else {// position to the bottom for top-level menus.
                        dropDownRef.current.style.top = '100%';
                    }
                    dropDownRef.current.style.width = size.width + 'px';
                    dropDownRef.current.style.opacity = '1';
                    
                    // Cancel any pending animation.
                    if (animationRef.current) {
                        animationRef.current.cancel?.();
                    }
                    
                    animationRef.current = dropDownRef.current.animate({height: [0, size.height + 'px']}, {
                        duration: 500,
                        easing: 'ease-in-out'
                    });
                    
                    // when the animation completes, set final hieght and show content.
                    animationRef.current.addEventListener('finish', () => {
                        if (dropDownRef.current && menusRef.current) {
                            dropDownRef.current.style.height = size.height + 'px';
                            menusRef.current.style.overflow = 'visible';
                        }
                    });
                }
            }
            // mark dropdown as open.
            setDroppedDown(true);
        }
    }

    const closeDropDown = () => {
        //+ Clear any pending close timout to prevent multiple timeouts from stacking up and causing unintended behavior.
        if (closeTimeoutRef.current) {
            clearTimeout(closeTimeoutRef.current);
            closeTimeoutRef.current = null;
        }
        //+ Mark dropdown as closed to prevent redundant state updates and animations.
        setDroppedDown(false);
        
        if (menuRef.current && dropDownRef.current && menusRef.current) {
            // cancle any opening animation to prevent conflicts with the closing animation and ensure smooth transitions.
            if (animationRef.current) {
                animationRef.current.cancel?.();
            }
            //+ Animate the dropdown menu closing by fading out.
            animationRef.current = dropDownRef.current.animate(
                {opacity: [1, 0]}, 
                {duration: 500}
            );
            // when animation completes, reset styles.
            animationRef.current.addEventListener('finish', () => {
                if (dropDownRef.current && menuRef.current && menusRef.current) {
                    dropDownRef.current.style.width = '0';
                    dropDownRef.current.style.height = '0';
                    dropDownRef.current.style.opacity = '0';
                    menuRef.current.style.overflow = 'hidden';
                    menusRef.current.style.overflow = 'hidden';
                }
            });
        }
    }

    const scheduleClose = (related) => {
        //+ Clear existing timeout first.
        if (closeTimeoutRef.current) {
            clearTimeout(closeTimeoutRef.current);
        }

        closeTimeoutRef.current = setTimeout(() => {
            const dropdownElement = dropDownRef.current;
            const container = menuRef.current;

            // Check if cursor actually left the menu and dropdown.
            if (dropdownElement && container) {
                if (related instanceof Node) {
                    // If the related target is not part of the dropdown or the menu button.
                    if (!dropdownElement.contains(related) && 
                        related !== dropdownElement &&
                        !container.contains(related)) {
                        closeDropDown();// Close the dropdown if the cursor is completely out.
                    }
                } else {
                    closeDropDown();// Close the dropdown if no valid related target.
                }
            }
        }, 30);// Schedule the close after a short delay to allow for rapid mouse movements.
    }

    const onMouseEnter = (e) => {
        e.preventDefault();
        setIsHovered(true);
        // Cancel any pending close.
        if (closeTimeoutRef.current) {
            clearTimeout(closeTimeoutRef.current);
            closeTimeoutRef.current = null;
        }
        dropDown();
        if (onEnter && typeof onEnter === 'function') onEnter(e);
    }

    const onMouseLeave = (e) => {
        e.preventDefault();
        setIsHovered(false);
        const related = e.relatedTarget;
        scheduleClose(related);
        if (onLeave && typeof onLeave === 'function') onLeave(e);
    }

    //+ Dropdown event handlers to keep it open during rapid movement.
    const onDropDownMouseEnter = (e) => {
        e.preventDefault();
        if (closeTimeoutRef.current) {
            clearTimeout(closeTimeoutRef.current);
            closeTimeoutRef.current = null;
        }
    }

    const onDropDownMouseLeave = (e) => {
        e.preventDefault();
        const related = e.relatedTarget;
        scheduleClose(related);
    }

    const handleClick = (e) => {
        e.stopPropagation();
        if (!menus || menus.length === 0) {
            if (setSelected) setSelected(name);
            if (closeParentDropDown) closeParentDropDown();
        }
    };

    return (
        <div
            ref={menuRef}
            onClick={handleClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            id={name}
            style={{transition: 'all .5s ease-in-out'}}
            className={`relative flex flex-row text-heading items-center overflow-hidden cursor-pointer shrink-0 capitalize ${
                isHovered ? 'bg-[rgb(230,230,230)]' : '' 
            }`}
        >
            {menus && menus.length > 0 ? (
                <>
                    <MenuText name={name} menus={menus} parentRef={parentRef} mobileMode={mobileMode}/>
                    <div ref={dropDownRef}
                         onMouseEnter={onDropDownMouseEnter}
                         onMouseLeave={onDropDownMouseLeave}
                         className="absolute left-0 top-full w-0 h-0 bg-[rgb(243,244,245)] custom-shadow z-40">
                        <div ref={menusRef} className="relative flex flex-col w-full h-full overflow-hidden">
                            {menus && menus.length > 0 && menus.map((menu, i) => (
                                <MenuButton
                                    key={i}
                                    name={menu.name ? menu.name : 'null'}
                                    link={menu.link ? menu.link : '/'}
                                    menus={menu.menus && menu.menus.length > 0 ? menu.menus : null}
                                    parentRef={menuRef}
                                    setSelected={setSelected}
                                    onEnter={onEnter}
                                    onLeave={onLeave}
                                    closeParentDropDown={closeDropDown}
                                />
                            ))}
                        </div>
                    </div>
                </>
            ) : (
                isInRouterContext ? (
                    <NavLink to={link ? link : '/'} className={({isActive}) => isActive ? 'text-[rgb(0,175,240)]' : 'text-[rgb(68,71,70)]'}>
                        <MenuText name={name} parentRef={parentRef}/>
                    </NavLink>
                ) : (
                    <MenuText name={name} parentRef={parentRef}/>
                )
            )}
        </div>
    );
};

const MenuText = ({name, menus, parentRef, isCalc, mobileMode}) => {
    return (
        <div className={`flex flex-row ${parentRef || mobileMode ? isCalc ? 'w-fit space-x-2 font-nunitoSansSemiBold' : 'w-full justify-between font-nunitoSansSemiBold' : 'font-nunitoSansBold w-fit space-x-2'} text-sm tracking-wider px-4 py-2 items-center shrink-0 capitalize`}>
            <p className='w-fit h-fit whitespace-nowrap'>{name}</p>
            {menus && menus.length > 0 ? parentRef ? <PiCaretRight size={16}/> : <PiCaretDown size={16}/> : <></>}
        </div>
    )
}